import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Button, Typography } from '@mui/material';
import { DisclosureTooltip } from '@repo/ui/DisclosureTooltip';
import { DriverLabel } from './DriverLabel';

export const Driver = ({
  label,
  value,
  tooltip,
}: {
  label: string;
  value?: string | null;
  tooltip?: string;
}) => {
  return (
    <>
      <Box
        sx={{
          p: { xs: 2, md: '20px' },
          display: 'flex',
          minWidth: { xs: '97px', sm: '130px' },
          flexDirection: 'column',
          alignItems: 'center',
          gap: { sm: '0.5rem', md: '1rem' },
          height: { xs: '60px', sm: '74px', md: '123px' },
          backgroundColor: label === 'APY' ? 'blues.lightest' : 'transparent',
        }}
      >
        <DriverLabel label={label} />
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography sx={{ fontSize: { xs: 16, md: 24 }, fontWeight: 600 }}>{value}</Typography>
          {tooltip && (
            <DisclosureTooltip
              tooltipStyleOverride={{
                maxWidth: '275px',
                paddingX: '1.5rem',
                paddingY: '12px',
              }}
              trigger={
                <Button
                  aria-label="NerdWallet rating info"
                  variant="cdRatesTooltip"
                  disableTouchRipple
                  sx={{ ml: '2px' }}
                >
                  <HelpOutlineIcon
                    sx={{
                      width: { xs: '12px', sm: '1rem' },
                      height: { xs: '12px', sm: '1rem' },
                      color: 'neutral.dark',
                    }}
                  />
                </Button>
              }
            >
              <Typography variant="textSmall">{tooltip}</Typography>
            </DisclosureTooltip>
          )}
        </Box>
      </Box>
    </>
  );
};
